<div class="min-w-550 p-15">
  <div class="pb-30">
    <span class="text-size-18 text-bold-700" mat-dialog-title>Configurações</span>
  </div>
  <form [formGroup]="form">
    <div
      *ngIf="data.type === 'document'"
      class="d-flex vw-100 column-gap-20 ptb-10"
    >
      <app-c-input
        class="form-input flex-1"
        label="CNPJ Beneficiário"
        formControlName="Document"
        inputMask="AA.AAA.AAA/AAAA-00"
        [uppercase]="true"
        [dropSpecial]="false"
      >
      </app-c-input>
    </div>

    <div
      *ngIf="data.type === 'default'"
      class="d-flex vw-100 column-gap-20 ptb-10"
    >
      <app-c-select
        class="flex-1"
        width="100%"
        height="33px"
        label="Banco"
        alignItem="flex-start"
        formControlName="Bank"
        borderRadius="5px"
        borderColor="#c4c4c4"
        [isStoreConfig]="true"
        [data]="data.reverseParameters?.bank || []"
      ></app-c-select>
      <app-c-select
        class="flex-1"
        width="100%"
        height="33px"
        label="Canal"
        alignItem="flex-start"
        formControlName="Channel"
        borderRadius="5px"
        borderColor="#c4c4c4"
        [isStoreConfig]="true"
        [data]="data.reverseParameters?.channel || []"
      ></app-c-select>
    </div>
    <div class="d-flex vw-100 column-gap-20 ptb-10">
      <app-c-select
        class="flex-1"
        width="100%"
        height="33px"
        label="Status do Contrato"
        alignItem="flex-start"
        formControlName="BatchStatus"
        borderRadius="5px"
        borderColor="#c4c4c4"
        [isStoreConfig]="true"
        [data]="data.reverseParameters?.contractStatus || []"
      ></app-c-select>
      <app-c-select
        class="flex-1"
        width="100%"
        height="33px"
        label="Tipo de Estorno"
        alignItem="flex-start"
        formControlName="ReversalType"
        borderRadius="5px"
        borderColor="#c4c4c4"
        [isStoreConfig]="true"
        [data]="data.reverseParameters?.reverseType || []"
      ></app-c-select>
    </div>
    <div class="d-flex vw-100 column-gap-20 ptb-10">
      <ng-container *ngIf="form.controls['IsValue'].value; else isPercent">
        <app-c-input
          class="form-input flex-1"
          label="Valor de Estorno (R$)"
          formControlName="Amount"
          [currencyMask]="true"
          inputMask="separator.2"
          separatorLimit="100000000000"
        >
        </app-c-input>
      </ng-container>

      <ng-template #isPercent>
        <app-c-input
          class="form-input flex-1"
          label="Valor de Estorno (%)"
          formControlName="Amount"
          inputType="number"
        >
        </app-c-input>
      </ng-template>

      <app-c-input
        class="form-input flex-1"
        label="Prazo para Estorno (Dias)"
        formControlName="Days"
        inputType="number"
      >
      </app-c-input>
    </div>

    <div
      class="d-flex vw-100 column-gap-20 pt-20 justify-space-evenly modal-footer footer"
    >
      <button class="ui-btn ui-btn--secondary w-170 h-36" mat-dialog-close>Cancelar</button>
      <button
        class="ui-btn ui-btn--primary w-170 h-36"
        [disabled]="form.invalid"
        (click)="handleReverseConfig()"
      >
        Salvar configuração
      </button>
    </div>
  </form>
</div>
